import React from 'react';

import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';

export default ({ outCount, handleRowCountSelect, rowsCount, handleSelectFilter, filterState, engineTypes }) => {
  const FORMULA_TYPES = [
    { name: 'All', value: 'All' },
    { name: 'Base', value: false },
    { name: 'Read-across', value: true },
  ];

  const FORMULA_STATUSES = [
    { name: 'All', value: 'All' },
    { name: 'Approved', value: 'APPROVED' },
    { name: 'Pending', value: 'PENDING' },
    { name: 'Incomplete', value: 'INCOMPLETE' },
    { name: 'Deactivated', value: 'DEACTIVATED' },
  ];

  const FEE_STATUSES = [
    { name: 'All', value: 'All' },
    { name: 'Unpaid', value: false },
    { name: 'Paid', value: true },
  ];

  const engineTypesWithAllField = ['All'].concat(engineTypes);

  const getSelectedItem = (key, possibleItemsList) => {
    if (filterState[key] === undefined) return possibleItemsList[0];
    return possibleItemsList.find(item => item.value === filterState[key]);
  };

  return (
    <section className='list-scene__utility-section-wrapper'>
      <section className='list-scene__utility-section-filters-wrapper'>
        <div className='list-scene__utility-section-filters-header'>Filter</div>
        <Select
          selectionList={FORMULA_TYPES}
          handleSelect={handleSelectFilter('isReadAcrossFormula')}
          placeholder='All'
          defaultItem={getSelectedItem('isReadAcrossFormula', FORMULA_TYPES)}
          label={'by Formulation Type'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <Select
          selectionList={engineTypesWithAllField}
          handleSelect={handleSelectFilter('engineType')}
          label={'by Engine Oil Type'}
          placeholder='All'
          defaultItem={filterState.engineType || engineTypesWithAllField[0]}
          type={selectType.listFilter}
        />
        <Select
          selectionList={FORMULA_STATUSES}
          handleSelect={handleSelectFilter('applicationStatus')}
          placeholder='All'
          defaultItem={getSelectedItem('applicationStatus', FORMULA_STATUSES)}
          label={'by Application Status'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <Select
          selectionList={FEE_STATUSES}
          handleSelect={handleSelectFilter('isPaid')}
          placeholder='All'
          defaultItem={getSelectedItem('isPaid', FEE_STATUSES)}
          label={'by Fee Status'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
      </section>

      <section className='list-scene__utility-section-rows-select-wrapper'>
        <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowCountSelect} selectedRowsCount={rowsCount} />
      </section>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/List/FiltersSection.jsx